import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import RewardsWOF from '@cont/Events/Rewards/WOF';
import {
  fetchRewardEvent,
  fetchRewardPrizeDetails
} from '@api/fetchers/rewards';

const EventRewards = ({
  eventUID,
  rewardEventDetails,
  fallbackRewardPrizeDetails
}) => {
  return (
    <>
      <RewardsWOF
        eventUID={eventUID}
        rewardEventDetails={rewardEventDetails}
        fallbackRewardPrizeDetails={fallbackRewardPrizeDetails}
      />
    </>
  );
};

EventRewards.pageInfo = {
  name: 'Unacademy Reward Event',
  isMWebSupported: true,
  layoutOptions: {
    hideHeader: true,
    hideFooter: true,
    hideSearch: true,
    hideGoalSelector: true,
    hideLearnerMinutes: true,
    hideNudges: true,
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export const getStaticProps = async ({ params }) => {
  const { rewardKey } = params;
  try {
    const rewardEventDetails = await fetchRewardEvent({ rewardKey });
    const eventUID = rewardEventDetails.eventUid;
    const fallbackRewardPrizeDetails = await fetchRewardPrizeDetails(eventUID);
    return {
      props: {
        eventUID,
        rewardEventDetails,
        fallbackRewardPrizeDetails
      },
      revalidate: 15
    };
  } catch (err) {
    return {
      props: {},
      revalidate: 15
    };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

export default EventRewards;
EventRewards.Layout = Layout;
EventRewards.Wrapper = PageReduxProvider;
